import { ChevronLeft, ChevronRight, Info, Play, Plus } from 'lucide-react';
import type { Series } from '../types';

interface HeroProps {
  series: Series;
  index: number;
  count: number;
  isInMyList: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onPlay: () => void;
  onDetails: () => void;
  onToggleMyList: () => void;
  onSelectIndex: (index: number) => void;
}

export function Hero({
  series,
  index,
  count,
  isInMyList,
  onPrevious,
  onNext,
  onPlay,
  onDetails,
  onToggleMyList,
  onSelectIndex
}: HeroProps) {
  return (
    <section className="hero" style={{ backgroundImage: `url(${series.heroImage})` }} aria-label={`Featured series: ${series.title}`}>
      <div className="hero-shade" />
      <button className="hero-arrow hero-arrow-left" onClick={onPrevious} aria-label="Previous featured series">
        <ChevronLeft />
      </button>
      <div className="hero-content">
        <span className="eyebrow">New series</span>
        <h1>{series.title}</h1>
        <p className="hero-tagline">{series.tagline}</p>
        <p className="hero-description">{series.description}</p>
        <div className="hero-meta">
          <span>{series.genres.join(' • ')}</span>
          <span>{series.episodes.length} episodes</span>
          <span>Episodes 1–4 free</span>
        </div>
        <div className="hero-actions">
          <button className="button button-primary" onClick={onPlay}>
            <Play size={18} fill="currentColor" /> Watch now
          </button>
          <button className="button button-secondary" onClick={onDetails}>
            <Info size={18} /> Details
          </button>
          <button className="button button-ghost" onClick={onToggleMyList}>
            <Plus size={18} /> {isInMyList ? 'In my list' : 'My list'}
          </button>
        </div>
      </div>
      <button className="hero-arrow hero-arrow-right" onClick={onNext} aria-label="Next featured series">
        <ChevronRight />
      </button>
      <div className="hero-dots" aria-label="Featured series selection">
        {Array.from({ length: count }, (_, dotIndex) => (
          <button
            key={dotIndex}
            className={dotIndex === index ? 'hero-dot active' : 'hero-dot'}
            onClick={() => onSelectIndex(dotIndex)}
            aria-label={`Show featured item ${dotIndex + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
